'use client'

import Link from 'next/link'
import DealCard from '@/components/DealCard'

export default function GuestGatedDealList({ deals, hidePhoto = false }) {
  const lockedCount = deals.filter(d => d._locked).length

  return (
    <div className="space-y-4">
      {deals.map((deal) => (
        <DealCard key={deal.id} deal={deal} hidePhoto={hidePhoto} locked={!!deal._locked} />
      ))}
      {lockedCount > 0 && (
        <div className="rounded-2xl border border-blue-100 bg-blue-50 p-5 text-center">
          <p className="text-sm font-semibold text-blue-900 mb-1">
            🔒 {lockedCount} more deal{lockedCount !== 1 ? 's' : ''} — members only
          </p>
          <p className="text-xs text-blue-700 mb-3">Sign up free to unlock all prices, dates and airports.</p>
          <Link href="/signup" className="inline-block bg-blue-600 text-white text-sm font-bold px-5 py-2 rounded-xl hover:bg-blue-700 transition-colors">
            Get free access →
          </Link>
        </div>
      )}
    </div>
  )
}
